import { Icon } from '@iconify/react'
import type { ReactNode } from 'react'
import styles from './WinnersSectionCard.module.css'

export interface WinnersSectionCardProps {
  id: string
  title: string
  subtitle?: string
  icon?: string
  headerAction?: ReactNode
  children: ReactNode
}

export function WinnersSectionCard({
  id,
  title,
  subtitle,
  icon = 'mdi:trophy-outline',
  headerAction,
  children,
}: WinnersSectionCardProps) {
  return (
    <section className={styles.card} aria-labelledby={id}>
      <header className={styles.header}>
        <div className={styles.headerText}>
          <h2 id={id} className={styles.title}>
            <Icon className={styles.titleIcon} icon={icon} aria-hidden />
            {title}
          </h2>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>
        {headerAction ? <div className={styles.headerAction}>{headerAction}</div> : null}
      </header>
      <div className={styles.body}>{children}</div>
    </section>
  )
}
